import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageSanSebastian = props => {
  return (
    <CityLandingPage
      cityKey="SanSebastian"
      cityLabel="sanSebastian"
      cityConfig={cityContent.sanSebastian}
      {...props}
    />
  );
};

export default LandingPageSanSebastian;
